import React from "react";
import AppLayout from "../components/AppLayout";
import Footer from "../components/Footer";
import "./Contato.css";

export default function Contato() {
  return (
    <AppLayout>
      <section className="contato-header">
        <h1>📬 Contato</h1>
        <p>Fale conosco ou envie sua sugestão</p>
      </section>

      <div className="contato-grid">
        {/* Informações de contato */}
        <div className="contato-info">
          <h3>Fale Conosco</h3>
          <p>📧 pro.scannerspro@gmail.com</p>
          <p>📱 Instagram: @scannerspro</p>
        </div>

        {/* Formulário de sugestões */}
        <form className="contato-form">
          <h3>Envie sua sugestão</h3>
          <input type="text" placeholder="Nome" />
          <input type="email" placeholder="E-mail" />
          <textarea placeholder="Sua sugestão"></textarea>
          <button type="submit">Enviar Mensagem</button>
        </form>
      </div>

      <div className="contato-footer">
        <p className="aviso">
          ⚠️ O ScannerPro não recomenda apostas. Jogue com responsabilidade.
        </p>
        <button className="ajuda">Buscar Ajuda</button>
      </div>

      <Footer />
    </AppLayout>
  );
}
